var tw = tw || {};
tw.FeastOrFiction = (function () {
	var _log = false,
		maxQuestions = 6,//10 for production
		questions = [],
		questionCurrentIndex = 0,
		correctAnswers = 0,
		resultsMessages = [],
		newsletter = [],
		culinaryCta = [],
		formText = [],
		fictionResponseReal = [],
		fictionResponseFake = [],
		holdData = null,
		isValid = false,
		errorMsg = ""
		;

	if (_log) console.log('init.tw.FeastOrFiction.js');

	/**
	 * Classes
	 */
	var Question = function (obj) {
		this.questionDescription = obj.questionDescription;
		this.responseDescription = obj.responseDescription;
		this.cardTrueImage = obj.cardTrueImage,
		this.cardFalseImage = obj.cardFalseImage,
		this.isTrue = obj.isTrue;
		this.title = obj.title;
		this.url = obj.url;
		this.iconLeft = obj.iconLeft;
		this.iconRight = obj.iconRight;
		//console.log('new Question:', this);
	}


	//TEMPLATES
	var progressTemplate = $('#progressTemplate').html(),
		questionTemplate = $('#questionTemplate').html(),
		newsletterImgTemplate = $('#newsletterImgTemplate').html(),
		introImageTemplate = $('#introImageTemplate').html()




	/**
	 * Initialize page
	 */
	var initializePage = function () {
		//if (_log) console.log('initializePage()');

		$('.js-quiz-play-now').on('click', function () {
			//console.log("js-quiz-play-now");
			$('.js-quiz-intro').addClass('hidden');
			loadQuestion(questionCurrentIndex);
		});

		$('body').on('click', '.js-quiz-answer-fest', function () {
			//console.log('.js-quiz-answer-fest.click');
			var isTrue = $(this).closest('.js-quiz-fest').attr('data-isTrue');
			//console.log('isTrue', isTrue);
			checkAnswer(true, isTrue);
		});
		
		$('body').on('click', '.js-quiz-answer-fiction', function () {
			//console.log('.js-quiz-answer-fiction.click');
			var isTrue = $(this).closest('.js-quiz-fest').attr('data-isTrue');			
			checkAnswer(false, isTrue);
		});

		$('body').on('click', '.js-quiz-next-question', function () {
			//console.log('.js-quiz-next-question.click');
			if (_log) console.log('questionCurrentIndex', questionCurrentIndex, ' of ', maxQuestions);
			if (questionCurrentIndex < maxQuestions - 1) {
				questionCurrentIndex ++;
				loadQuestion(questionCurrentIndex);
			} else {
				if (_log) console.log('show results');
				showResults();
			}
		});

		$('body').on('click', '.js-quiz-form-submit', function () {
			//if (_log) console.log("click share");
			postToForm($(this));
		});

		$('body').on('click', '.js-fest-link', function () {
			//if (_log) console.log('fest link');
			var festName = $(this).text();
			tw.Analytics.ga4('Fest or Fiction', 'Event Link', festName);
		});

		$('body').on('click', '.social-share-button a', function () {
			//if (_log) console.log('social share');
			tw.Analytics.ga4('Fest or Fiction', 'Share', '');
		});

		//REMOVED FROM FORM, FOR NOW
		// $('.js-quiz-form-required').on('change', function () {
		// 	//if (_log) console.log("change");
		// 	//if (_log) console.log($(this).find('input[type=checkbox]'));
		// 	if ($(this).find('input[type=checkbox]').is(':checked')) {
		// 		//if (_log) console.log("it's checked");
		// 		$('.js-quiz-form-submit').removeClass('button--disabled').prop('disabled', '');
		// 	} else {
		// 		$('.js-quiz-form-submit').addClass('button--disabled').prop('disabled', 'disabled');
		// 	}
		// });

		$('body').on('click', '.js-quiz-play-again', function () {
			//console.log('.js-quiz-play-again.click');
			$('.js-form-content').removeClass('hidden');
			$('.js-form-thankyou').addClass('hidden');
			reloadQuestions();
			$('.js-quiz-skip').removeClass('hidden');
		});

		

		getContent('/JS/tw/quiz/feast-or-fiction/data/data.json');

		$('.js-quiz-skip').on('click', function (e) {
			e.preventDefault();
			$('.js-quiz-skip').addClass('hidden');
			$('.js-quiz-intro').addClass('hidden');
			$('.js-quiz-progress').addClass('hidden');
			$('.js-quiz-load-question').addClass('hidden');
			$('.js-quiz-rules').addClass('hidden');
			$('.js-quiz-results-wrapper').removeClass('hidden');
			$('.js-quiz-score').addClass('hidden');
			
			$('.js-form-heading').html(formText.skippedHeading);
			$('.js-form-description').html(formText.skippedDescription);
		})
	}

	
	var validateForm = function () {

		isValid = true;
		//var phoneRegex = "^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$"
		var emailRegex = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$"

		errorMsg = ""

		if (!$('#Email').val().match(emailRegex)) {
			isValid = false;
			errorMsg = "Please enter a valid email."
		}
		else if ($('#FirstName').val() == "") {
			isValid = false;
			errorMsg = "Please enter a Name."
		}
		// else if (!$('#Phone').val().match(phoneRegex)) {
		// 	isValid = false;
		// 	errorMsg = "Please enter a valid 10 digit phone number."
		// }
		// else if (!$('#Agreed').is(":checked")) {
		// 	isValid = false;
		// 	errorMsg = "You must be 18 to enter."
		// }

		if (_log) console.log('isValid: ', isValid, errorMsg);
	}


	/**
	 * Submit Share by Email form
	 * @param {*} button 
	 */
	var postToForm = function (button) {
		validateForm();
		var form = button.parents("form");
		if (_log) console.log('form:', $(form).serialize());
		if (isValid) {
			$('.js-quiz-error-message').addClass('hidden');

			$.ajax({
				type: "POST",
				url: '/sweepstakes/submitfeastorfictionsweepstakesform?sweepstakesType=FeastOrFiction',
				data: $(form).serialize(),
				success: function (data) {
					if (_log) console.log('shareByEmail.success.data:', data);
					$('.js-form-content').addClass('hidden');
					$('.js-form-thankyou').removeClass('hidden');

				},
				error: function (xhr, status, err) {
					console.error(xhr, status, err);
					alert("Sorry! Your submission cannot be processed at this time.")
				}
			});

		}
		else {
			$('.js-quiz-error-message').html(errorMsg);
			$('.js-quiz-error-message').removeClass('hidden');
		}
	} 

	/**
	 * Get content from local json
	 * @param {*} dataPath 
	 */
	var getContent = function (dataPath) {
		if (_log) console.log('getContent()', dataPath);
		var jqxhr = $.getJSON(dataPath, function (data) {
			if (_log) console.log( "getContent.data:", data);

				holdData = data;//hold this data to shuffle and reload later
				resultsMessages = data.resultsMessages;
				newsletter = data.newsletter;
				culinaryCta = data.culinaryCta;
				formText = data.formText;
				fictionResponseReal = data.fictionResponses.real;
				fictionResponseFake = data.fictionResponses.fake;

				if (_log) console.log('fictionResponseReal', fictionResponseReal);
				if (_log) console.log('fictionResponseFake', fictionResponseFake);

				$('.js-quiz-version').html(data.version);

				processContent(data);
			})
			.fail(function (err) {
				console.error("error:", err);
			});
	}



	/**
	 * Process content from JSON file, Shuffle, trim array
	 * @param {*} data 
	 */
	var processContent = function (data) {
		if (_log) console.log('processContent()', data);
		
		var tempArr = shuffleArray(data.questions);//randomize questions
		var compiledTemplate = Template7.compile(progressTemplate);
		var html = '';


		for (var i = 0; i < maxQuestions; i ++) {
			var question = new Question(tempArr[i]);
			//console.log('question', question);
			questions.push(question);

			var jsonContent = {
				id: i
			};
			//if (_log) console.log('jsonContent:', jsonContent);
			html += compiledTemplate(jsonContent);
			
		}
		$('.js-quiz-progress-loader').append(html);

		if (_log) console.log('questions', questions);
		loadIntroPage(data);
	}
	
	
	var loadIntroPage = function (data) {
		var compiledTemplate = Template7.compile(introImageTemplate);
		
		$('.js-quiz-intro-heading').html(data.landingPage.heading)
		$('.js-quiz-intro-description-1').html(data.landingPage.descriptionOne)
		$('.js-quiz-intro-description-2').html(data.landingPage.descriptionTwo)
		$('.js-quiz-play-now').html(data.landingPage.buttonText)
		$('.js-quiz-prize-heading').html(data.landingPage.prizes.heading)
		$('.js-quiz-prize-1').html(data.landingPage.prizes.prize1);
		$('.js-quiz-prize-2').html(data.landingPage.prizes.prize2);
		$('.js-quiz-prize-3').html(data.landingPage.prizes.prize3);
		$('.js-quiz-prize-rules').html(data.landingPage.prizes.ctaText)
		$('.js-quiz-prize-rules').attr('href', data.landingPage.prizes.ctaLink)
		
		var introImageContent = {
			imageMobile: data.landingPage.mobileImage,
			imageDesktop: data.landingPage.desktopImage
		};
		var introImageHtml = compiledTemplate(introImageContent)

		$('.js-intro-image').html(introImageHtml);
	}

	/**
	 * Load question template
	 * @param {*} index 
	 */
	var loadQuestion = function (index) {
		if (_log) console.log('loadQuestion()', index);

		$('.js-quiz-response').html('');
		$('.js-quiz-load-question').html('');
		$('.js-question-number').html(index + 1)
		if(!$('.js-quiz-response').hasClass('hidden')) $('.js-quiz-response').addClass('hidden');
		if(!$('.js-quiz-response').hasClass('hidden')) $('.js-quiz-description').addClass('hidden');

		var question = questions[index];
		var isLast = ((questionCurrentIndex + 1) == maxQuestions) ? true : false;
		var compiledTemplate = Template7.compile(questionTemplate);

		var jsonContent = {
			index: index + 1,
			questionDescription: question.questionDescription,
			responseDescription: question.responseDescription,
			cardTrueImage: question.cardTrueImage,
			cardFalseImage: question.cardFalseImage,
			isTrue: question.isTrue,
			isLast: isLast,
			title: question.title,
		};
		if (_log) console.log('jsonContent:', jsonContent);

		var html = compiledTemplate(jsonContent);

		$('.js-quiz-load-question').html(html);
		if($('.js-quiz-load-question').hasClass('hidden')) $('.js-quiz-load-question').removeClass('hidden');
		if ($('.js-quiz-progress').hasClass('hidden')) $('.js-quiz-progress').removeClass('hidden');
		if ($('.js-quiz-rules').hasClass('hidden')) $('.js-quiz-rules').removeClass('hidden');
		$('.js-quiz-choice').removeClass('hidden');
	}



	/**
	 * Check answer, update stage
	 * @param {*} answered 
	 * @param {*} isTrue 
	 */
	var checkAnswer = function (answered, isTrue) {
		isTrue = JSON.parse(isTrue);
		if (_log) console.group('checkAnswer()');
		if (_log) console.log('answered:', answered);
		if (_log) console.log('isTrue:', isTrue);

		var responseMessage = '';
		var random = 0;

		if (isTrue) {
			if (answered) {
				if (_log) console.log('isTrue && user answered Fest/True');
				responseMessage = fictionResponseReal[random];
				correctAnswers ++;

			} else {
				if (_log) console.log('isTrue && user answered Fiction/False');
       			responseMessage = fictionResponseReal[random];
			}
		} else {
			if (answered) {
				if (_log) console.log('is NOT Fest && user answered Fest/True');
				random = Math.floor((Math.random() * fictionResponseFake.length));
				responseMessage = fictionResponseFake[random];

			} else {
				if (_log) console.log('is NOT Fest && user answered Fiction/False');
				random = Math.floor((Math.random() * fictionResponseReal.length));
				responseMessage = fictionResponseFake[random];
				correctAnswers ++;
			}
		}

		//console.log('random', random);
		if (_log) console.log('responseMessage', responseMessage);


		$('.js-quiz-response').html(responseMessage);
		$('.js-quiz-progress-mark-' + questionCurrentIndex).addClass("complete").find('sr-only').append(" complete");
		$('.js-quiz-response').removeClass('hidden');
		$('.js-quiz-description').removeClass('hidden');
		$('.js-quiz-next-question').removeClass('hidden');
		$('.js-quiz-choice').addClass('hidden');

		if (_log) console.groupEnd();
	}


	/**
	 * Reload questions, clear out divs, reset vars
	 */
	var reloadQuestions = function () {
		$('.js-quiz-response').addClass('hidden');
		$('.js-quiz-description').addClass('hidden');
		$('.js-quiz-load-question').addClass('hidden');
		$('.js-quiz-progress').addClass('hidden');

		$('.js-quiz-next-question').addClass('hidden');
		$('.js-quiz-results-wrapper').addClass('hidden');

		$('.js-quiz-results-score').html('');
		$('.js-quiz-results-message').html('');
		$('.js-quiz-progress').find('.js-quiz-progress-mark').remove();

		questionCurrentIndex = 0;
		questions = [];
		correctAnswers = 0;

		processContent(holdData);
		loadQuestion(questionCurrentIndex);
	}

	/**
	 * Show results, hide questions
	 */
	var showResults = function () {
		var percCorrect = Math.ceil((correctAnswers / maxQuestions) * 100),
			percRange = 0;
		
		if (percCorrect == 100) {
			percRange = 100;
			$('.js-quiz-result-status').html(resultsMessages.passText)
		} else if(percCorrect > 50) {
			percRange = 75;
			$('.js-quiz-result-status').html(resultsMessages.passText)
		} else if (percCorrect > 25) {
			percRange = 50;
			$('.js-quiz-result-status').html(resultsMessages.failText)
		} else {
			percRange = 25;
			$('.js-quiz-result-status').html(resultsMessages.failText)
		}
		var message = resultsMessages['perc' + percRange];

		if (_log) console.log('percCorrect', percCorrect);
		if (_log) console.log('percRange', percRange);

		$('.js-quiz-results-score').html('');

		for (var i=0; i <= correctAnswers; i++) {
			var perc = Math.ceil((i / maxQuestions) * 100); 
			var number = i + 1;
			var delay = (number / 5) + "s";
			var hidden = true;
			if (i == (correctAnswers - 1)) {
			  hidden = false;
			}
			$('.js-quiz-results-score').append("<span class='ani--scroll-up d-flex align-items-start' style='animation-delay:" + delay + "' aria-hidden='" + hidden + "'><span class='text-108 lh-sm'>" + perc + "</span><span class='text-36'>%</span>"); 
		}
		$('meta[name=tw_quizScore]').attr('content', percCorrect);
		$('.js-quiz-results-message').html(message);
		$('.js-quiz-results-wrapper').removeClass('hidden');
		$('.js-quiz-skip').addClass('hidden');

		$('.js-form-heading').html(formText.heading);
		$('.js-form-description').html(formText.description);

		$('.js-5050-heading').html(culinaryCta.heading);
		$('.js-5050-description').html(culinaryCta.description);
		$('.js-5050-cta').attr('href', culinaryCta.cta.url);
		$('.js-5050-cta').html(culinaryCta.cta.text);
		$('.js-5050-image').attr({
			'src': culinaryCta.backgroundImage + '?width=700&height=475&scale=both&mode=crop',
			'alt': culinaryCta.backgroundImageDescription
		});
		
		$('.js-newsletter-kicker').html(newsletter.kicker);
		$('.js-newsletter-heading').html(newsletter.heading);
		$('.js-newsletter-button').attr('href', newsletter.cta.link);
		$('.js-newsletter-button').html(newsletter.cta.text);

		var compiledCalloutImageTemplate = Template7.compile(newsletterImgTemplate);
		var calloutImgHtml = '';
		var calloutJsonContent = {
			calloutImageUrlSmall: newsletter.backgroundImageMobile,
			calloutImageUrlLarge: newsletter.backgroundImageDesktop
		};
		calloutImgHtml += compiledCalloutImageTemplate(calloutJsonContent);

		$('.js-newsletter').append(calloutImgHtml);

		$('.js-quiz-progress').addClass('hidden');
		$('.js-quiz-load-question').addClass('hidden');
		$('.js-quiz-rules').addClass('hidden');
	}


	/**
	 * Randomize array element order in-place. Using Durstenfeld shuffle algorithm.
	 */
	var shuffleArray = function (array) {
		//console.log('shuffleArray()');
		for (var i = array.length - 1; i > 0; i--) {
			var j = Math.floor(Math.random() * (i + 1));
			var temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
		return array;
	}


	$(initializePage); //doc ready

}());